<div class="card border-0 position-relative">
  <button type="button" class="confirm-dialog__close" (click)="closed.emit()" aria-label="Close">
    <i class="fa-solid fa-xmark"></i>
  </button>

  <div class="card-body p-4 p-sm-5">
    <img src="/assets/images/logo_image.png" alt="UNC Biometric" class="img-fluid m-auto d-table mb-3" />
    <h4 class="text-center mb-3">Change Password Verification</h4>
    <p class="text-center mb-4">
      Your password change is protected with email verification. Enter the code sent to your email below.
    </p>

    <form novalidate (ngSubmit)="verify()">
      <div
        class="form-group mb-3 d-flex align-items-center justify-content-center gap-4 text-center otp-bar flex-wrap whitespace-nowrap"
        (paste)="onOtpPaste($event)"
      >
        @for (digit of digits(); track $index; let i = $index) {
          <input
            #digitInput
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="1"
            class="otp-input__box"
            [attr.aria-label]="'Digit ' + (i + 1)"
            [value]="digit"
            (input)="onOtpDigitInput(i, $event)"
            (keydown)="onOtpKeydown(i, $event)"
          />
        }
      </div>

      <p class="fs-6 mb-3 text-center">
        The change password verification code has been successfully sent to your registered email.
        <span class="text-blue">{{ emailId }}</span>
      </p>

      <button type="submit" class="w-75 btn btn-primary mb-3 m-auto d-table" [disabled]="loading()">
        {{ loading() ? 'Verifying…' : 'Verify' }}
      </button>

      <p class="fs-6 text-center">
        It may take a minute to receive your code.<br />
        Haven’t received it?
        <a
          (click)="resend()"
          class="text-primary cursor-pointer fw-bold"
          [class.disabled-link]="!resendEnabled() || resending()"
        >
          {{ resending() ? 'Sending…' : 'Resend a new code' }}
        </a>
      </p>
    </form>

    <div class="expire-info text-center">
      @if (remainingSeconds() > 0) {
        <p>
          Expire in <span>{{ minutes }} : {{ seconds }}</span>
        </p>
      } @else {
        <p>
          <span class="text-danger">Time Expired</span>
        </p>
      }
    </div>
  </div>
</div>
